<template>
  <div class="activity-details">
    <header class="activity-header-info">
      <div class="activity-time">有效期：{{details.beginTime}}至{{details.endTime}}</div>
      <div class="activity-title">{{details.title}}</div>
      <div class="activity-text"></div>
    </header>
    <div class="details-block">
      <section class="activity-content">
        <div class="activity-icon">活动类型</div>
        <div class="activity-type">
          <span>{{details.campaignTypeDesc}} </span>
          <span>适用人群: 活动用户</span>
        </div>
      </section>
      
      <section class="activity-content">
        <div class="activity-icon">优惠券使用范围</div>
          <p class="p-title">可使用站点</p>
          <p class="">
            {{ staList.join(",") }}
          </p>
      </section>
      <section class="activity-content">
        <div class="activity-icon">活动说明</div>
        <p class="">{{details.remark}}</p>
      </section>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pi-activity-5',
  props : {
    details:{
      type: Object,
      default:()=>{
        return {}
      }
    },
    staList:{
      type: Array,
      default:()=>{
        return []
      }
    }
  },
  data(){
    return {

    }
  }
}
</script>